module.exports = __webpack_public_path__ + "img/player_icon_4.b188c0f8.svg";